export const SET_LOADING_DATA = '@orderType/SET_LOADING_DATA';
export const SET_LOADING_SEND = '@orderType/SET_LOADING_SEND';

//LIST
export const GET_ALL_REQUEST = '@orderType/GET_ALL_REQUEST';
export const GET_ALL_SUCCESS = '@orderType/GET_ALL_SUCCESS';

export const DELETE_ITEM = '@orderType/DELETE_ITEM';
export const EDIT_ITEM = '@orderType/EDIT_ITEM';

export const SEARCH = '@orderType/SEARCH';

export const SET_PAGE = '@orderType/SET_PAGE';
export const SET_ROWS_PER_PAGE = '@orderType/SET_ROWS_PER_PAGE';
export const SET_ORDER = '@orderType/SET_ORDER';
export const SET_ORDERBY = '@orderType/SET_ORDEBY';

//FORM
export const GET_BY_ID_REQUEST = '@orderType/GET_BY_ID_REQUEST';
export const GET_BY_ID_SUCCESS = '@orderType/GET_BY_ID_SUCCESS';

export const SAVE_REQUEST = '@orderType/SAVE_REQUEST';
export const SAVE_SUCCESS = '@orderType/SAVE_SUCCESS';

export const UPDATE_FIELD = '@orderType/UPDATE_FIELD';
